import { buildApiUrl } from "./apiConfig";

const ensureFetcher = (fetchWithAuth) => {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required.");
  }
  return fetchWithAuth;
};

async function parseJsonResponse(response, fallbackMessage) {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.detail || fallbackMessage);
  }
  return payload;
}

export async function fetchInvoices(fetchWithAuth) {
  const runner = ensureFetcher(fetchWithAuth);
  const response = await runner(buildApiUrl("/admin/invoices"));
  const payload = await parseJsonResponse(response, "Rechnungen konnten nicht geladen werden.");
  return Array.isArray(payload?.invoices) ? payload.invoices : [];
}

export async function fetchInvoiceDetail(fetchWithAuth, invoiceId) {
  const runner = ensureFetcher(fetchWithAuth);
  const response = await runner(buildApiUrl(`/admin/invoices/${invoiceId}`));
  const payload = await parseJsonResponse(response, "Rechnungsdetails konnten nicht geladen werden.");
  return payload?.invoice ?? null;
}

export async function updateInvoiceStatus(fetchWithAuth, invoiceId, status) {
  const runner = ensureFetcher(fetchWithAuth);
  const response = await runner(buildApiUrl(`/admin/invoices/${invoiceId}/status`), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status }),
  });
  const payload = await parseJsonResponse(response, "Rechnungsstatus konnte nicht aktualisiert werden.");
  return payload?.invoice ?? null;
}
